import z from 'zod'

export const zLocalFileWithUrl = z.object({
  source: z.literal('local'),
  url: z.url(),
  file: z.file(),
})
export const zRemoteFileWithUrl = z.object({
  source: z.literal('remote'),
  url: z.url(),
  key: z.string(),
  file: z.object({ name: z.string(), type: z.string(), size: z.number() }),
})

export const zFileWithUrl = zLocalFileWithUrl.or(zRemoteFileWithUrl)

export type FileWithUrl = z.infer<typeof zFileWithUrl>
export type RemoteFileWithUrl = z.infer<typeof zRemoteFileWithUrl>
export type LocalFileWithUrl = z.infer<typeof zLocalFileWithUrl>

/**
 * Synthetic placeholder used for empty canvas slots before the user uploads or
 * generates real media. It carries `source: 'remote'` so it renders from its
 * URL, but its `key` is NOT a real S3 object. It must never be sent to
 * `asset.copyAsset` / `asset.delete`: the backend ownership guard rejects any
 * key outside the user's prefix, which surfaces as an unhandled client error.
 * Use `isPlaceholderFile` to skip it at every asset mutation boundary.
 */
export const PLACEHOLDER_ASSET_KEY = 'placeholder.png'
export const PLACEHOLDER_ASSET_URL = 'https://placeholder.invalid/placeholder.png'

/** True when `file` is the synthetic placeholder rather than a real S3 asset. */
export const isPlaceholderFile = (file: FileWithUrl): boolean =>
  file.source === 'remote' && file.key === PLACEHOLDER_ASSET_KEY
